import { ReactionType } from './types';

export const DefaultShortcode = ':thumbsup:';

export const ShortcodeMap: Record<string, ReactionType> = {
	'star-struck': ReactionType.Amaze,
	clap: ReactionType.Celebrate,
	heart: ReactionType.Love,
	laughing: ReactionType.Laugh,
	thumbsup: ReactionType.Like,
};
